/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/lenta'>.
 * exact; render.ready — проверить пререндер
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../CacheDataRoute';
import Articles from '@routes/Articles';

export const Route = createFileRoute('/lenta/')({
  component: () => <CacheDataRoute component={Articles} path='/lenta' />
});
